<template>
    <div class="collapsible" :class="{ 'collapsible--active': isActive }">
        <template v-if="isLink">
            <a :href='link' class="collapsible__title" :class="{ 'd-flex align-items-center justify-content-between': !isDisabled }">
                <div><slot name="title"></slot></div>
            </a>
        </template>

        <template v-else>
            <h3 @click="toggle()" class="collapsible__title" :class="{ 'd-flex align-items-center justify-content-between': !isDisabled }">
                <div><slot name="title"></slot></div>
                <div class="toggle" v-if="!isDisabled && !isLink">
                    <span class="toggle__icon" :class=" isActive ? 'icon-iconmonstr-arrow-65-3-2' : 'icon-iconmonstr-arrow-65-3-3'"></span>
                </div>
            </h3>
            <collapse-transition>
                <div v-show="isActive">
                    <div class="collapsible__content">
                        <div class="collapsible__collapse-buttons d-flex d-md-none justify-content-between" v-if="showCloseFilters">
                            <a href="javascript:void(0);" @click="closeFilter()">Filter By  <span class="toggle__icon" :class=" isFilter ? 'icon-iconmonstr-arrow-65-3-2' : 'icon-iconmonstr-arrow-65-3-3'"></span></a>
                            <a href="javascript:void(0);" @click="closeSort()">Sort By  <span class="toggle__icon" :class=" isSort ? 'icon-iconmonstr-arrow-65-3-2' : 'icon-iconmonstr-arrow-65-3-3'"></span></a>
                        </div>
                        <slot></slot>
                    </div>
                </div>
            </collapse-transition>
        </template>

    </div>
</template>

<script>
/*
* Collapsible Vue component
* ---
* Example usage:
*
* <collapsible>
*   <template v-slot:title>Accordion Title</template>
*   <template>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</template>
* </collapsible>
*/

import Accordion from './collapsible.vue';


import {CollapseTransition} from 'vue2-transitions';

export default {   
    name: 'collapsible', 
    components: {
        Accordion,
        CollapseTransition
    },

    props: ["isDisabled","isOpen","isFilter","isSort","isFilterClosed","isSortClosed", "isLink", "link"],
    
   

    data() {
        return {
            isActive: false,
            showCloseFilters: false,
            filterString: '',
            isFilterOpen: this.isFilterClosed,
            isSortOpen: this.isSortClosed

        }
    },     
     watch:{
           isFilterClosed: function(newVal, oldVal) { // watch it
                this.isActive = !this.isActive;
                this.isFilterOpen = newVal;

            },
            isSortClosed: function(newVal, oldVal){
                this.isSortOpen = newVal;
                this.isActive = !this.isActive;
            }
            
    },   

    created() {
        if (this.isDisabled) {
            this.isActive = true;
        }
        if(this.isFilter || this.isSort) {
            this.showCloseFilters = true;
            if(this.isFilter) {
                this.filterString = 'Filter'
            } else {
                this.filterString = 'Sort'
            }
        }
    },
     mounted() {
 
    },

    methods: {
        toggle() {
            if (this.isDisabled) return;
            if(this.isSort){
                this.$emit('close-filter');
                this.isActive = !this.isActive;
                this.isFilterOpen = false;
                this.isSortOpen = true;
            } else if(this.isFilter) {
                this.$emit('close-sort');
                this.isActive = !this.isActive;
                this.isFilterOpen = true;
                this.isSortOpen = false;
            } else {
                this.isActive = !this.isActive;
            }

        },

        close() {
            if (this.isDisabled) return;
        },
        closeFilter () {
            if(this.isFilter){
                this.isActive = !this.isActive;
                this.isFilterOpen = false;
            } else if(this.isSort) {
                this.$emit('close-sort');
                this.isActive = !this.isActive;
                this.isFilterOpen = false;
                this.isSortOpen = true;
            } 
   
        },
        closeSort () {
            if(this.isSort){
                this.isActive = !this.isActive;
                this.isFilterOpen = !this.isFilterOpen;
                this.isSortOpen = false;
            } else  {
                this.$emit('close-filter');
                this.isActive = !this.isActive;
                this.isFilterOpen = false;
            }
        },
        showCollapse() {
            if(this.isActive && this.isFilterOpen){
                return true;
            } else if(this.isActive) {
                return true;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
h3 {
    cursor: pointer;
    font-size: 12px;
}

.toggle {
    &__icon {
        display: inline-block;
        transition: all 0.3s ease-in-out;
        font-size: 12px;
    }
}
</style>
